import { Drawer, DrawerContent, DrawerOverlay } from '@chakra-ui/react'
import React from 'react'
import { SidebarProps } from './interface'
import SidebarMenu from './SidebarMenu'

const Sidebar: React.FC<SidebarProps> = ({ ...props }) => {
  return (
    <>
      <SidebarMenu maxW="220px" display={{ base: 'none', lg: 'flex' }} />
      <Drawer placement="left" {...props}>
        <DrawerOverlay />
        <DrawerContent maxW="220px">
          <SidebarMenu />
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default Sidebar
